export default __webpack_public_path__ + "static/media/heart-crossed.97e691cd.svg";